import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Landmark, Check } from "lucide-react";

const fmt = (n) => Number(n || 0).toLocaleString("pt-BR");
const COLORS = {
  CEBRASPE: "from-emerald-500/20 to-emerald-600/5 border-emerald-500/40",
  CESGRANRIO: "from-blue-500/20 to-blue-600/5 border-blue-500/40",
};

// Grade visual de bancas da experiência principal (CEBRASPE + CESGRANRIO),
// com contagem REAL de questões vinda da API.
export const BancaGrid = ({ value, onSelect, includeTodas = true }) => {
  const [bancas, setBancas] = useState([]);
  useEffect(() => {
    api.get("/bancas").then((r) => setBancas(r.data.bancas || [])).catch(() => {});
  }, []);

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3" data-testid="banca-grid">
      {includeTodas && (
        <button data-testid="banca-todas" onClick={() => onSelect("Todas")}
          className={`rounded-2xl border p-4 text-left transition-all ${
            value === "Todas" ? "border-emerald-400 bg-emerald-400/10" : "border-slate-800 bg-slate-900 hover:border-slate-700"
          }`}>
          <Landmark className="h-5 w-5 text-slate-400" />
          <p className="mt-2 text-sm font-bold text-white">Todas</p>
          <p className="text-xs text-slate-500">CEBRASPE + CESGRANRIO</p>
        </button>
      )}
      {bancas.map((b) => (
        <button key={b.banca} data-testid={`banca-${b.banca.toLowerCase()}`} onClick={() => onSelect(b.banca)}
          className={`relative rounded-2xl border bg-gradient-to-br p-4 text-left transition-all ${
            COLORS[b.banca] || "from-slate-800 to-slate-900 border-slate-700"
          } ${value === b.banca ? "ring-2 ring-emerald-400" : ""}`}>
          {value === b.banca && <Check className="absolute right-3 top-3 h-4 w-4 text-emerald-400" />}
          <Landmark className="h-5 w-5 text-white/80" />
          <p className="mt-2 text-sm font-extrabold text-white">{b.banca}</p>
          <p className="font-mono-stats text-xs text-emerald-300">{fmt(b.count)} questões</p>
        </button>
      ))}
    </div>
  );
};
